import { Card, Flex, Stack, Text } from '@instamenu/ui-system-next';
import { LinkNext } from '@instamenu/ui-system-next';
import { formatAddress, formatDistance } from '@instamenu/formatters';
import { Address } from '@instamenu/data-access';
import { palette, themeVars } from '@instamenu/ui-vanilla-extract';
import { MapPin } from 'lucide-react';

type LocationProps = {
  restaurant: {
    id: string;
    name?: string | null;
    distance?: number;
    address?: Partial<Address> | null;
  };
};

export const Location = ({ restaurant }: LocationProps) => {
  return (
    <Stack css={{ paddingTop: 16 }}>
      <LinkNext
        prefetch={false}
        rel="canonical"
        style={{ width: '100%' }}
        href={`/locations/${restaurant.id}`}
      >
        <Card css={{ padding: '1.3em' }}>
          <Flex css={{ alignItems: 'center', gap: 16 }}>
            <MapPin size={28} color={themeVars.color.brand} />
            <Stack style={{ flex: 1, gap: 2 }}>
              <Text variant="subtitle1">{restaurant.name}</Text>
              <Text variant="caption2" css={{ color: palette.gray500 }}>
                {formatAddress(restaurant.address)}
              </Text>
            </Stack>
            <Text variant="caption2">
              {restaurant.distance ? `${formatDistance(restaurant.distance)}   ` : null}
            </Text>
          </Flex>
        </Card>
      </LinkNext>
    </Stack>
  );
};
